import classNames from "classnames"

export default function ContentBox({
  children,
  className,
  isPaddingless,
  isScrollableY,
}) {
  const classes = classNames(
    "rounded-md border shadow-sm border-gray-50 bg-white",
    className,
    {
      "p-5": !isPaddingless,
      "overflow-y-auto": isScrollableY,
    }
  )
  return <div className={classes}>{children}</div>
}
